import { tg } from "@/constants/telegram";

export const closeTG = () =>
  setTimeout(() => {
    tg.close?.();
  }, 200);

